import React from 'react';

// The presentational half of what `aws-amplify-react` used to supply. That
// package is v3-only -- it imports the v3 `Auth` singleton -- so it had to go
// with the v6 upgrade, but nothing about these components was tied to Amplify:
// each is a plain element carrying a class name and the inline styles from the
// `AuthTheme` object in auth-theme.js. The class names are the ones the old
// package emitted (from @aws-amplify/ui) so the rendered DOM is unchanged; no
// stylesheet in this app targets them, the styling is entirely the theme prop.

const merge = (style, themeStyle) => ({ ...style, ...themeStyle });

export const FormContainer = ({ theme = {}, children }) => (
  <div className="Form__formContainer___1GA3x" style={theme.formContainer}>
    {children}
  </div>
);

export const FormSection = ({ theme = {}, style, children, ...rest }) => (
  <FormContainer theme={theme}>
    <div
      {...rest}
      className="Form__formSection___1PPvW"
      style={merge(style, theme.formSection)}
    >
      {children}
    </div>
  </FormContainer>
);

export const SectionHeader = ({ theme = {}, style, children, ...rest }) => (
  <div
    {...rest}
    className="Section__sectionHeader___2djyg"
    style={merge(style, theme.sectionHeader)}
  >
    <span
      className="Section__sectionHeaderContent___1UCqa"
      style={theme.sectionHeaderContent}
    >
      {children}
    </span>
  </div>
);

export const SectionBody = ({ theme = {}, style, children, ...rest }) => (
  <div
    {...rest}
    className="Section__sectionBody___ihqqd"
    style={merge(style, theme.sectionBody)}
  >
    {children}
  </div>
);

export const SectionFooter = ({ theme = {}, style, children, ...rest }) => (
  <div
    {...rest}
    className="Section__sectionFooter___1T54C"
    style={merge(style, theme.sectionFooter)}
  >
    {children}
  </div>
);

export const SectionFooterPrimaryContent = ({ theme = {}, children }) => (
  <span
    className="Section__sectionFooterPrimaryContent___2r9ZX"
    style={theme.sectionFooterPrimaryContent}
  >
    {children}
  </span>
);

export const SectionFooterSecondaryContent = ({ theme = {}, children }) => (
  <span
    className="Section__sectionFooterSecondaryContent___Nj41Q"
    style={theme.sectionFooterSecondaryContent}
  >
    {children}
  </span>
);

export const FormField = ({ theme = {}, style, children, ...rest }) => (
  <div
    {...rest}
    className="Form__formField___38Ikl"
    style={merge(style, theme.formField)}
  >
    {children}
  </div>
);

export const Input = ({ theme = {}, style, ...rest }) => (
  <input
    {...rest}
    className="Input__input___3e_bf"
    style={merge(style, theme.input)}
  />
);

export const InputLabel = ({ theme = {}, children }) => (
  <div className="Input__inputLabel___3VF0S" style={theme.inputLabel}>
    {children}
  </div>
);

export const Hint = ({ theme = {}, children }) => (
  <div className="Hint__hint___2XngB" style={theme.hint}>
    {children}
  </div>
);

export const Button = ({
  theme = {},
  style,
  disabled = false,
  children,
  ...rest
}) => (
  <button
    {...rest}
    className="Button__button___vS7Mv"
    style={merge(style, theme.button)}
    disabled={disabled}
  >
    {children}
  </button>
);

export const Link = ({ theme = {}, style, children, ...rest }) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <a {...rest} className="Anchor__a___1_Iz8" style={merge(style, theme.a)}>
    {children}
  </a>
);

// The old Authenticator surfaced auth errors in a fixed-position toast; the
// `toast` key in AuthTheme is what styled it. Same markup as v3's Toast: a
// bare span (so the text sits at the left of the flex row, textAlign does not
// centre a flex item) and an empty close link. v3's × came from Amplify's
// stylesheet, which this app never loaded, so users never saw one.
export const Toast = ({ theme = {}, onClose, children }) => (
  <div className="Toast__toast___XXw3T" style={theme.toast}>
    <span>{children}</span>
    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */}
    <a className="Toast__toastClose___0f8_D" onClick={onClose} />
  </div>
);
